// Vendor imports
const { createSelector } = require('reselect')
// Client lib imports
const businessEvents = require('client/lib/business-events')

function trackAppDownload(platform) {
  businessEvents.trackSegment('app-download', { platform })
}

function trackExtensionDownload(browser) {
  businessEvents.trackSegment('extension-download', { browser })
}

const appPromosSelector = createSelector(
  state => state.env.deeplinkUrls,
  deeplinkUrls => [
    {
      type: 'app',
      id: 'android',
      title: 'Download our Android app',
      href: deeplinkUrls.get('android'),
      onClick: () => trackAppDownload('android')
    },
    {
      type: 'app',
      id: 'ios',
      title: 'Download our iOS app',
      href: deeplinkUrls.get('ios'),
      onClick: () => trackAppDownload('ios')
    }
  ]
)

const extensionPromos = [
  {
    type: 'extension',
    id: 'chrome',
    name: 'Chrome',
    title: 'Install our Chrome extension',
    href: 'https://chrome.google.com/webstore/detail/mix/pakcjidblmfebhbgoggdgbjkpjhefpgh',
    onClick: () => trackExtensionDownload('chrome')
  },
  {
    type: 'extension',
    id: 'firefox',
    name: 'Firefox',
    title: 'Install our Firefox Add-on',
    href: 'https://addons.mozilla.org/en-US/firefox/addon/mix-ext/',
    onClick: () => trackExtensionDownload('firefox')
  },
  {
    type: 'extension',
    id: 'msedge',
    name: 'Edge',
    title: 'Install our Edge extension',
    href: 'https://microsoftedge.microsoft.com/addons/detail/jffkbfhhjokopidblbjfkippklbhegoj',
    onClick: () => trackExtensionDownload('msedge')
  },
  {
    type: 'extension',
    id: 'safari',
    name: 'Safari',
    title: 'Install our Safari extension',
    href: 'https://itunes.apple.com/us/app/mix/id1451360134?mt=12',
    onClick: () => trackExtensionDownload('safari')
  }
]

const allPromosSelector = createSelector(
  [
    appPromosSelector,
    () => extensionPromos
  ],
  (appPromos, extensionPromos) => [
    ...appPromos,
    ...extensionPromos
  ]
)

const browserPromoSelector = createSelector(
  [
    allPromosSelector,
    state => state.env.browser
  ],
  (allPromos, browser) => {
    for (let promo of allPromos) {
      if (browser.get(promo.id)) {
        return promo
      }
    }
  }
)

function createPromoForIdSelector() {
  return createSelector(
    [
      allPromosSelector,
      (state, id) => id
    ],
    (allPromos, id) => {
      if (id) {
        return allPromos.find(promo => promo.id === id)
      }
    }
  )
}

module.exports = {
  appPromosSelector,
  extensionPromos,
  allPromosSelector,
  browserPromoSelector,
  createPromoForIdSelector
}
